import React, { useState, useEffect } from 'react'
import '../CSS/Profile_page.css'
import profilePhoto from '../img/profilePhoto.png'
import { useStateValue } from '../StateProvider'
import Button from "@material-tailwind/react/Button";
import { Link } from 'react-router-dom'
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import NavOnlyIcons from './NavOnlyIcons';
import SubFooter from './SubFooter';

const Profile_Page = () => {

    const [userData, setUserData] = useState(localStorage.getItem('user'));
    const [{user}] = useStateValue();
    useEffect(() => {
        setUserData(JSON.parse(window.localStorage.getItem('user')));
    }, []);

    
    const [date, setDate] = useState(new Date());
    const [name, setName] = useState(user?.displayName);
    const [email, setEmail] = useState(user?.email);
    const [phone, setPhone] = useState('9898878765');
    const [gender, setGender] = useState('Male');
    const [pass, setPass] = useState(user?.metadata.a);
    const [enable,setEnable] = useState(true);
    const [act, setAct ] = useState(false);
    const [showCalender, setshowCalender] = useState();

    const [activeEmail, setActiveEmail] = useState(false);
    const [activePhone, setActivePhone] = useState(false);
    const [activeGen, setActiveGen] = useState(false);
    const [activePass, setActivePass] = useState(false);


    const handleUser = (e) => {
        setshowCalender(true)
        setAct(true);
    }

    const handleEmailEdit = () => {
        setAct(true);
        setEnable(false);
        setActiveEmail(true);
    }

     const handlePhoneEdit = () => {
        setAct(true);
        setEnable(false);
        setActivePhone(true);
    }

    const handleActiveGen = () => {
        setAct(true);
        setEnable(false);
        setActiveGen(true);
    }

     const handleActivePass = () => {
        setAct(true);
        setEnable(false);
        setActivePass(true);
    }

    return (
        <>
        
        <div className="Profile_container">
            <div className="dipNav">
                <NavOnlyIcons/>
            </div>
            <div className="newUserProfile">
                <div className="newUserProfileDiv">

                    <div className="newUserProfileHead">
                        <h2>Account Settings</h2>
                    </div>


                    <div className="newUserProfileDetails">
                        <div className="newUserProfileOptions">
                            <p id='activeOptionNewUser'>PROFILE</p>
                            <p>EDIT</p>
                        </div>
                        <div className="userImagesAnDetails">
                            <div className="newUserImg">
                                <img src={userData ? (userData.photoURL) : (profilePhoto)} alt="user" />
                                <input type="file"  name="profileImg" id="profileImg" />
                                <label for="profileImg">CHANGE</label>
                                
                            </div>
                            
                            <div className="newUserDetails">
                                <div className="newUserDetailsInputs">
                                    <label htmlFor="name">
                                        Name
                                    </label>
                                    <div>
                                        <input type="text" name="name" 
                                        id="name"
                                        placeholder={userData.displayName}
                                        disabled={enable}
                                        value={name}
                                        onChange={e => setName(e.target.value)}
                                        />
                                        <i className="fas fa-check"></i>
                                    </div>
                                </div>

                                <div className="newUserDetailsInputs">
                                    <label htmlFor="email">Email</label>
                                    <div>
                                        <input 
                                        type="text" 
                                        placeholder={userData.email} 
                                        name="email" 
                                        id="email" 
                                        disabled={enable}
                                        value={email}
                                        onChange={e => setEmail(e.target.value)}
                                        className={activeEmail ? 'activeEdit' : ''}
                                        />
                                        <i className="fas fa-pencil-alt" onClick={(e) => handleEmailEdit()}></i>
                                    </div>
                                </div>

                                <div className="newUserDetailsInputs">
                                    <label htmlFor="phone">Phone</label>
                                    <div>
                                        <input type="text" name="phone" 
                                        id="phone" 
                                        placeholder={userData.lastLoginAt} 
                                        disabled={enable}
                                        value={phone}
                                        onChange={e => setPhone(e.target.value)}
                                        className={activePhone ? 'activeEdit' : ''}
                                        />
                                        <i className="fas fa-pencil-alt" onClick={(e) => handlePhoneEdit()}></i>
                                    </div>
                                </div>
                                
                                <div className="newUserDetailsInputs">
                                    <label htmlFor="dob">Gender</label>
                                    <div>
                                        <input type="text" name="dob" 
                                        id="dob" 
                                        value={gender}
                                        placeholder={user?.metadata.creationTime}
                                        disabled={enable}
                                        onChange={e => setGender(e.target.value)}
                                        className={activeGen ? 'activeEdit' : ''}
                                        />
                                        <i className="fas fa-pencil-alt" onClick={(e) => handleActiveGen()}></i>
                                    </div>
                                </div>

                                <div className="newUserDetailsInputs">
                                    <label htmlFor="password">Password</label>
                                    <div>
                                        <input type="text" name="password" 
                                            id="password" 
                                            value={pass} 
                                            placeholder={userData.createdAt}
                                            disabled={enable}
                                            onChange={e => setPass(e.target.value)}
                                            className={activePass ? 'activeEdit' : ''}
                                            />
                                        <i className="fas fa-pencil-alt" onClick={(e) => handleActivePass()}></i>
                                    </div>
                                </div>
                                {/*
                                <div className="newUserDetailsInputs">
                                    <label htmlFor="cpass"></label>
                                    <div>
                                        <input type="text" name="cpass" id="cpass" placeholder='●●●●●●●●'/>
                                        <i className="fas fa-check"></i>
                                    </div>
                                </div>
                                */}
                                <div className="newUserDetailsInputs">
                                    <label htmlFor="dob">DOB</label>
                                    <div>
                                        <input type="text" name="dob" 
                                        id="dob" 
                                        value={date.toLocaleDateString()}
                                        placeholder={user?.metadata.creationTime}/>
                                        <i className="far fa-calendar-alt" onClick={e => handleUser()}></i>
                                    </div>
                                    
                                </div>

                                <div className="calenderDivProfile">
                                    { showCalender ? (
                                        <Calendar
                                            onChange={setDate}
                                            value={date}
                                        />
                                    ) : ('') }
                                    
                                </div>
                                   
                            </div>

                        </div>
                        
                    </div>
                    { act ? (
                        <div className="saveBtnDiv">
                            <Button color="lightBlue" size="lg" ripple="light" onClick={handleUser}>
                                <Link to='/dashboard'>save</Link>
                            </Button>
                        </div>
                    ) : ('') }
                    
                </div>
            </div>
        { /*
        <div className="Profile_containerSubDiv">
            <h2>Account Settings</h2>
            <div className='profilePage' id='profile'>
                
                <div className="profileDiv_1">
                    <div className="ProfileAvatar">
                        <img src={user ? (user?.photoURL) : (profilePhoto)} alt='profile Photo' />                        
                    </div>
                    {
                        act ? (
                            <div className="editProfilePhoto" id='editProfilePhoto'>
                                <input type="file" onChange={(e) => setPic(e.target.files[0])}/>
                            </div> ) : (
                                ''
                            )
                    }
                    
                </div>

                <div className="profileDiv_2">
                    <Button id='editDetailsBtn' color="lightBlue" size="lg" ripple="light" onClick={(e) =>  handleUser()}>
                       
                        Edit <i className="fas fa-pencil-alt"></i>    
                    </Button>
                    <div className="profileDiv_2Options">
                        <h3>Name : </h3>
                        <span>
                            <input className={act ? 'activeInput' : '' } type="text" disabled={enable} placeholder={user?.displayName}/>
                            <button onClick={(e) =>  handleUser()}><i className="fas fa-pencil-alt"></i></button>
                        </span>
                    </div>
                    <div className="profileDiv_2Options">
                        <h3>Email :  </h3>
                        <span>
                                <input className={act ? 'activeInput' : '' } type="text" disabled={enable} placeholder={user?.email}/>
                            <button onClick={(e) =>  handleUser()}><i className="fas fa-pencil-alt"></i></button>
                        </span>
                    </div>
                    <div className="profileDiv_2Options">
                        <h3>Phone :  </h3>
                        <span>
                            <input className={act ? 'activeInput' : '' } type="text" disabled={enable} placeholder={user?.metadata.a} />
                        </span>
                    </div> 
                    <div className="profileDiv_2Options">
                        <h3>DOB : </h3>
                        <span>
                            <input className={act ? 'activeInput' : '' } type="text" disabled={enable} placeholder={user?.metadata.creationTime} />
                            <button onClick={(e) =>  handleUser()}><i className="fas fa-pencil-alt"></i></button>
                        </span> 
                    </div> 
                    <div className="profileDiv_2Options">
                        <h3>Gender : </h3>
                        <span>
                            <input className={act ? 'activeInput' : '' } type="text" disabled={enable} placeholder='Male'/>
                            <button onClick={(e) =>  handleUser()}><i className="fas fa-pencil-alt"></i></button>
                        </span> 
                    </div>  
                </div>

                
            </div>

            <div className="Login_heading">
                <h2>Login Credentials :</h2>
            </div>
            <div className="loginCreds">
               
                
                <div className="userCredentials">
                    <div className="profileDiv_2Options">
                        <h3>Name : </h3>
                        <span>
                            <input className={act ? 'activeInput' : '' } type="text" disabled={enable} placeholder={user?.displayName}/>
                            <button onClick={(e) =>  handleUser()}><i className="fas fa-pencil-alt"></i></button>
                        </span>
                    </div>
                    <div className="profileDiv_2Options">
                        <h3>Email :  </h3>
                        <span>
                            <input className={act ? 'activeInput' : '' } type="text" disabled={enable} placeholder={user?.email}/>
                            <button onClick={(e) =>  handleUser()}><i className="fas fa-pencil-alt"></i></button>
                        </span>
                    </div>
                   <div className="profileDiv_2Options">
                        <h3>Pass :  </h3>
                        <span>
                            <input className={act ? 'activeInput' : '' } type="text" disabled={enable} placeholder={user?.metadata.a}/>
                            <button onClick={(e) =>  handleUser()}><i className="fas fa-pencil-alt"></i></button>
                        </span>
                    </div> 
                </div>
                <div className="profileDiv_2Button">
                {
                    !enable ? (
                        <Button color="lightBlue" size="lg" ripple="light" onClick={handleUser}>save</Button>
                    ) : ('')
                }   
                </div>  
            </div>
            </div>
            */ }
        </div>
        <SubFooter />    
        </>
    )
}

export default Profile_Page
